import React from 'react';
import styled from '@emotion/styled';

import { Icon } from '../../../../main/scripts/lumen';
import { Dropdown } from '../../../../main/scripts/shell';

export const ProjectKebabMenu = ({ onCopy, onRename, onDelete }) => (
  <Dropdown
    align="right"
    trigger={
      <TriggerButton type="button" aria-label="Project actions">
        <Icon name="more" size={16} />
      </TriggerButton>
    }
  >
    {onCopy && (
      <Item type="button" onClick={onCopy}>
        <Icon name="copy" size={14} />
        <span>Copy</span>
      </Item>
    )}
    {onRename && (
      <Item type="button" onClick={onRename}>
        <Icon name="edit" size={14} />
        <span>Rename</span>
      </Item>
    )}
    {onDelete && (
      <>
        <Divider />
        <Item type="button" $danger onClick={onDelete}>
          <Icon name="trash" size={14} />
          <span>Delete</span>
        </Item>
      </>
    )}
  </Dropdown>
);

const TriggerButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 1px solid ${({ theme }) => theme.color.slate[200]};
  border-radius: 8px;
  background: ${({ theme }) => theme.color.bg.default};
  cursor: pointer;
  color: ${({ theme }) => theme.color.fg.muted};

  &:hover {
    background: ${({ theme }) => theme.color.bg.subtle};
    color: ${({ theme }) => theme.color.fg.default};
  }
`;

const Item = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 16px;
  background: transparent;
  border: 0;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  text-align: left;
  color: ${({ $danger, theme }) => ($danger ? '#B91C1C' : theme.color.fg.default)};

  &:hover {
    background: ${({ $danger, theme }) =>
      $danger ? theme.color.red[50] : theme.color.bg.subtle};
  }

  & > svg {
    color: ${({ $danger, theme }) => ($danger ? '#B91C1C' : theme.color.fg.subtle)};
    flex-shrink: 0;
  }
`;

const Divider = styled.div`
  height: 1px;
  background: #d9d9d9;
`;
